import { DeleteOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useState } from 'react';

export const LocalizedModal = ({ fetchListDevices, setValue, actualSegment }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setValue('');
    fetchListDevices(actualSegment);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button type='primary' onClick={showModal} style={{ width: '100%', position: 'relative' }} danger>
        <DeleteOutlined />
      </Button>
      <Modal
        title='Подтвердите действие'
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText='Отмена'
      >
        <p>Вы действительно хотите удалить это устройство?</p>
      </Modal>
    </>
  );
};
